module.exports = __webpack_public_path__ + "static/img/ios_pa.8f2b3fbf.png";